<template>
  <div class="basicinfo-container">
    <div class="basicinfo-container_ cen">
      <div class="inside-main">
        <div class="basicinfo-main">
          <div class="volunteer-detail-item">基本信息</div>
          <div class="basicinfo-form">
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">姓名：</div>
              <div class="basicinfo-input"><input type="text" v-model="formdata.name" class="input"></div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">居住地址：</div>
              <div class="basicinfo-input"><input type="text" v-model="formdata.address" class="input"></div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">性别：</div>
              <div class="basicinfo-input">
                <label for="sex01"><input type="radio" v-model="formdata.sex" value="1" id="sex01">女</label>
                <label for="sex02"><input type="radio" v-model="formdata.sex" value="0" id="sex02">男</label>
              </div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">出生日期：</div>
              <div class="basicinfo-input" id="date">
                <select name="year" id="year" class="birthdayselect">
                  <option value="">选择年份</option>
                </select>
                <select name="month" id="month" class="birthdayselect">
                  <option value="">选择月份</option>
                </select>
                <select name="days" id="days" class="birthdayselect">
                  <option value="">选择日期</option>
                </select>
              </div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">民族：</div>
              <div class="basicinfo-input">
                <select v-model="formdata.nationality">
                  <option value="汉族">汉族</option>
                  <option value="其他">其他</option>
                </select>
              </div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">文化程度：</div>
              <div class="basicinfo-input">
                <select v-model="formdata.education">
                  <option v-for="(item, index) in educationList" :key="index" :value="item.dataname">{{item.dataname}}</option>
                </select>
              </div>
            </div>
            <div class="basicinfo-inputbox">
              <div class="basicinfo-item">居住情况：</div>
              <div class="basicinfo-input">
                <select v-model="formdata.living">
                  <option value="0">独居</option>
                  <option value="1">非独居</option>
                </select>
              </div>
            </div>
            <div class="basicinfo-btn" @click="updateInfo">保存</div>
          </div>
        </div>
        <div class="inside-left-nav">
          <div class="left-nav-head">
            <div class="chname">我的首页</div>
            <div class="enname">Member Center</div>
          </div>
          <div class="left-nav-list">
            <div class="left-nav-li active">
              <router-link to="/member/index" class="left-nav-link">
                <div class="chname">基本信息</div>
                <div class="enname">Basic Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/security" class="left-nav-link">
                <div class="chname">个人安全信息</div>
                <div class="enname">Personal Safety Information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/reserve" class="left-nav-link">
                <div class="chname">预约信息</div>
                <div class="enname">Reservation information</div>
                <span></span>
              </router-link>
            </div>
            <div class="left-nav-li">
              <router-link to="/member/family" class="left-nav-link">
                <div class="chname">我的家庭</div>
                <div class="enname">My Family</div>
                <span></span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderData, getMemberData, updateMemberData, getEducationData } from '../../api/getData.js'
import { selectDate } from '../../assets/js/select.js'
export default {
  name: 'basicInfo',
  data () {
    return {
      headerInfo: {},
      educationList: [],
      formdata: {
        name: '',
        address: '',
        sex: '1',
        birthday: '',
        nationality: '',
        education: '',
        living: ''
      }
    }
  },
  metaInfo () {
    return {
      title: this.headerInfo.title,
      meta: [
        { name: 'generator', content: this.headerInfo.generator },
        { name: 'author', content: this.headerInfo.author },
        { name: 'keywords', content: this.headerInfo.keywords },
        { name: 'description', content: this.headerInfo.description }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ])
  },
  mounted () {
    let self = this
    window.$('#date').selectDate()
    window.$('#days').change(function () {
      let year = window.$('#year option:selected').val()
      let month = window.$('#month option:selected').val()
      let day = window.$('#days option:selected').val()
      self.formdata.birthday = year + '-' + month + '-' + day
    })
  },
  created () {
    this.getHeaderInfo()
    this.getEducation()
    this.getMemberInfo()
  },
  methods: {
    async getHeaderInfo () {
      let header = await getHeaderData()
      this.headerInfo = header.header
      this.$store.dispatch('SetActiveMenu', { activeMenu: 'member', activeSendMenu: 'member' }).then(() => {}).catch(() => {})
    },
    async getEducation () {
      let result = await getEducationData()
      this.educationList = result.list_e
    },
    async getMemberInfo () {
      let postData = { id: this.getUserId }
      let result = await getMemberData(postData)
      this.formdata.name = result.info.cnname
      this.formdata.address = result.info.address
      this.formdata.sex = result.info.sex
      this.formdata.birthday = result.info.birthday
      this.formdata.nationality = result.info.nation
      this.formdata.education = result.info.education
      this.formdata.living = result.info.livestatus
      window.$('#year').val(result.info.birthday_y)
      window.$('#year').trigger('change')
      window.$('#month').val(result.info.birthday_m)
      window.$('#month').trigger('change')
      window.$('#days').val(result.info.birthday_d)
    },
    async updateInfo () {
      let postData = {}
      postData.id = this.getUserId
      postData.cnname = this.formdata.name
      postData.address = this.formdata.address
      postData.sex = this.formdata.sex
      postData.birthday = this.formdata.birthday
      postData.nation = this.formdata.nationality
      postData.education = this.formdata.education
      postData.livestatus = this.formdata.living
      let result = await updateMemberData(postData)
      if (result.code === '1') {
        this.message('修改成功')
        this.getMemberInfo()
      } else {
        this.message('修改失败')
      }
    },
    message (content) {
      this.$alert(content, '提示', {
        confirmButtonText: '确定',
        callback: action => {}
      })
    }
  }
}
</script>

<style scoped lang="less">
  .inside-main{
    padding: 40px 0 60px;
  }
  .basicinfo-main{
    width: 77.22%;
    padding: 0 0 78px;
    background-color: #ffffff;
    box-shadow: 0px 0px 13px 0px rgba(37, 37, 37, 0.15);
    border-radius: 5px;
    .volunteer-detail-item{
      border-left: 4px solid #eb6420;
      margin-top: 60px;
      margin-left: 62px;
      padding-left: 25px;
      font-size: 30px;
      line-height: 30px;
      color: #eb6420;
    }
    .basicinfo-form{
      margin-top: 42px;
      padding-bottom: 62px;
      .basicinfo-inputbox{
        margin-bottom: 43px;
        overflow: hidden;
        .basicinfo-item{
          float: left;
          width: 187px;
          margin-right: 3px;
          font-size: 24px;
          line-height: 40px;
          text-align: right;
          color: #333333;
        }
        .basicinfo-input{
          overflow: hidden;
          .input{
            width: 435px;
            height: 40px;
            border-radius: 5px;
            background-color: #eeeeee;
            padding: 0 10px;
            font-size: 18px;
            line-height: 40px;
            color: #333333;
          }
          label{
            margin-right: 105px;
            font-size: 24px;
            line-height: 40px;
            color: #666666;
            input{
              width: 13px;
              height: 13px;
              margin-top: 13px;
              margin-right: 10px;
              appearance: none;
              background-image: url("../../assets/images/radio-icon.png");
              background-repeat: no-repeat;
              background-position: -152px center;
              &:checked{
                background-position: 0 center;
              }
            }
          }
          select{
            width: 200px;
            height: 40px;
            border: none;
            border-radius: 5px;
            background: #eeeeee url('../../assets/images/select.png') no-repeat right center;
            margin-right: 40px;
            padding: 0 0 0 20px;
            font-size: 18px;
            line-height: 40px;
            color: #333333;
            appearance: none;
            outline: none;
          }
        }
      }
      .basicinfo-btn{
        width: 200px;
        height: 50px;
        margin: 110px auto 0;
        border-radius: 4px;
        background-color: #eb6420;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  @media screen and (max-width: 1300px){
    .basicinfo-main{
      .basicinfo-form{
        .basicinfo-inputbox{
          .basicinfo-input{
            select{
              margin-right: 15px;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px){
    .inside-main{
      padding: 25px 0 5px;
    }
    .basicinfo-main{
      width: 100%;
      margin-bottom: 20px;
      padding: 30px 0 65px;
      border-radius: 3px;
      .volunteer-detail-item{
        border-left: 2px solid #eb6420;
        margin-top: 0;
        margin-left: 30px;
        padding-left: 12px;
        font-size: 15px;
        line-height: 15px;
      }
      .basicinfo-form{
        margin-top: 21px;
        padding-bottom: 0;
        padding-left: 30px;
        padding-right: 30px;
        .basicinfo-inputbox{
          margin-bottom: 13px;
          .basicinfo-item{
            float: none;
            width: 100%;
            margin-right: 0;
            font-size: 14px;
            line-height: 32px;
            text-align: left;
          }
          .basicinfo-input{
            .input{
              width: 100%;
              height: 30px;
              border-radius: 3px;
              padding: 0 10px;
              font-size: 12px;
              line-height: 30px;
            }
            label{
              margin-right: 52px;
              font-size: 12px;
              line-height: 26px;
              input{
                width: 6px;
                height: 6px;
                margin-top: 12px;
                margin-right: 5px;
                background-size: auto 6px;
                background-position: -70px center;
                &:checked{
                  background-position: 0 center;
                }
              }
            }
            select{
              width: 157px;
              height: 30px;
              border-radius: 3px;
              background-size: 30px 30px;
              margin-right: 7px;
              padding: 0 0 0 10px;
              font-size: 12px;
              line-height: 30px;
              &.birthdayselect{
                width: 75px;
                &:last-child{
                  margin-right: 0;
                }
              }
            }
          }
        }
        .basicinfo-btn{
          width: 100px;
          height: 25px;
          margin: 45px auto 0;
          border-radius: 2px;
          font-size: 14px;
          line-height: 25px;
        }
      }
    }
    .inside-left-nav{
      display: none;
    }
  }
</style>
